import { memo } from 'react';
import { Separator } from 'src/components/Separator/Separator';
import { LanguagesSelector } from 'src/modules/locales/components/Languages/components/LanguagesSelector';
import { GameCategories } from './GameCategories';
import { Pages } from './Pages';
import { LiveChatButton } from './LiveChatButton';
import { PwaButton } from './PwaButton';
import { useCheckPWA } from 'src/hooks/useCheckPWA';
import { GPTButtonsBlock } from 'src/modules/GPTGame/components/GPTButtonsBlock';
import { SidebarShopBanner } from 'src/modules/Promo/SidebarShopBanner';

const _SidebarContent = () => {
  const IS_PWA = useCheckPWA();

  return (
    <div className="flex flex-col items-center justify-start w-full gap-5">
      <Separator width="w-[100%]" noMarginTop />
      <GPTButtonsBlock />
      <SidebarShopBanner />
      <GameCategories />
      <Separator width="w-[100%]" noMarginTop />
      <Pages />
      <Separator width="w-[100%]" noMarginTop />
      <LiveChatButton />
      <Separator width="w-[100%]" noMarginTop />
      {!IS_PWA && (
        <>
          <div className="w-full px-2">
            <PwaButton />
          </div>
          <Separator width="w-[100%]" noMarginTop />
        </>
      )}
      <div className="w-full px-2">
        <LanguagesSelector />
      </div>
    </div>
  );
};

export const SidebarContent = memo(_SidebarContent);
